import { getFrontImage } from '@grandvisionhq/utils';
import { getActiveVariant } from '../../helpers.js';

const getProductImageData = (product, sku, width)=>{
    var ref;
    const variant = getActiveVariant(product, sku);
    const calculatedWidth = Math.floor(width);
    const image = getFrontImage((ref = variant.media) === null || ref === void 0 ? void 0 : ref.images);
    return {
        url: `${image.url}?w=${calculatedWidth}&fm=jpeg&auto=format`,
        dimensions: image.dimensions
    };
};

export { getProductImageData };
//# sourceMappingURL=get-product-image-data.js.map
